// User-facing Italian labels for the RC Professionale form fields that can
// block submit. Unlike the stepped funnels this is a single-page form, so
// there's no per-step field list — handleSubmit's onInvalid callback hands
// back every blocking field across the whole form in one go.
export const FIELD_LABELS = {
  profession: 'Professione',
  high_risk: 'Attività ad alto rischio',
  retroactivity: 'Retroattività',
  billed: 'Fatturato anno in corso',
  billed_maximum: 'Massimale',
  has_no_accident: 'Dichiarazione sinistri',
  gender: 'Il contraente è',
  business_name: 'Ragione sociale',
  vat_number: 'Partita IVA',
  company_type: 'Tipologia azienda',
  name: 'Nome',
  surname: 'Cognome',
  date_of_birth: 'Data di nascita',
  commune_of_birth_code: 'Comune di nascita',
  province_of_birth_code: 'Provincia di nascita',
  born_abroad: "Nato all'estero",
  country_of_birth_code: 'Stato estero di nascita',
  residence_commune_code: 'Comune di residenza',
  residence_province_code: 'Provincia di residenza',
  postal_code: 'CAP',
  address: 'Indirizzo',
  house_number: 'Numero civico',
  policy_effective_date: 'Data di inizio copertura',
  email: 'Email',
  phone: 'Telefono',
  rc_professionale_email: 'Mail del cliente',
  rc_professionale_phone: 'Numero di telefono del cliente',
};

// The whole form is one "step" — every key in the errors object handleSubmit
// hands back is blocking.
export const getBlockingFields = (errors) => Object.keys(errors || {});

// Keep the list short enough to stay readable inside a toast.
export const buildMissingFieldsMessage = (fields, labels = FIELD_LABELS, max = 3) => {
  const names = (fields || []).map((field) => labels[field] || field);
  if (names.length === 0) {
    return 'Per favore, completa i campi obbligatori.';
  }
  if (names.length > max) {
    return `Compila i campi obbligatori: ${names.slice(0, max).join(', ')} e altri ${names.length - max}.`;
  }
  return `Compila i campi obbligatori: ${names.join(', ')}.`;
};
